import * as THREE from 'three';
import 'pepjs';

export default class RaytraceManager {

    constructor(config) {

        let defaultConfig = {
            container: 'blueprint'
        };

        this.config = deepmerge(defaultConfig, config);

        // generate native dom and jquery references to the container
        this.$container = $(this.container);
        this.raycaster  = new THREE.Raycaster();
        this.mouse      = new THREE.Vector2();

        this.hitArr = [];

        // store a reference to body for the application of css pointer
        this.$body = $("body");

        this.enabled = true;

        let self = this;

        document.getElementById( "Timeline" ).addEventListener( "pointerdown", function(event){  self.onDocumentMouseDown(event); });
        window.addEventListener('mousemove', this.onDocumentMouseMove.bind(this), false);

        return this;

    }

    addObject(threeObj) {

        if (!this.hitArr.indexOf(threeObj) > -1) {
            this.hitArr.push(threeObj);
        }

    }

    removeObject(threeObj) {

        let index = this.hitArr.indexOf(threeObj);
        if (index > -1) {
            this.hitArr.splice(index, 1);
        }

    }

    onDocumentTouchStart(event) {

        //event.preventDefault();

        event.clientX = event.touches[0].clientX;
        event.clientY = event.touches[0].clientY;
        this.onDocumentMouseDown(event);

    }

    onDocumentMouseDown(event) {

        //event.preventDefault();

        if (this.enabled && event.target.nodeName == 'CANVAS') {

            this.raycaster.camera = window.timeline.cameramanager.camera;

            let cy = event.clientY;
            cy -= window.timeline.renderer.domElement.getBoundingClientRect().top;

            this.mouse.x = (event.clientX / window.timeline.renderer.domElement.clientWidth) * 2 - 1;
            this.mouse.y = -(cy / window.timeline.renderer.domElement.clientHeight) * 2 + 1;

            this.raycaster.setFromCamera(this.mouse, window.timeline.cameramanager.camera);

            // @todo
            let mode = (window.timeline.config.cmsMode == true) ? true : false;
            let intersects = this.raycaster.intersectObjects(this.hitArr, mode);

            //intersects = this.raycaster.intersectObjects(window.scene.children, true);
            if (intersects.length > 0) {

                let rayobj = intersects[0].object;
                let raytype = (typeof (rayobj.userData) != "undefined") ? rayobj.userData.type : "all";

                document.dispatchEvent(new CustomEvent("raytrace_event",
                    {
                        detail: {
                            rayobjectname: rayobj.name,
                            rayintersects: intersects,
                            interaction: "click",
                            type: raytype,
                            ctrlKey: event.ctrlKey,
                        }
                    }));

            }
        }

    }


    onDocumentMouseMove(event) {

        event.preventDefault();
        event.stopPropagation();

        // intensive, only do this if not animating
        if (this.enabled && event.target.nodeName == 'CANVAS') {

            let cy = event.clientY;
            cy -= window.timeline.renderer.domElement.getBoundingClientRect().top;

            this.mouse.x = (event.clientX / window.timeline.renderer.domElement.clientWidth) * 2 - 1;
            this.mouse.y = -(cy / window.timeline.renderer.domElement.clientHeight) * 2 + 1;

            this.raycaster.setFromCamera(this.mouse, window.timeline.cameramanager.camera);

            let intersects = this.raycaster.intersectObjects(this.hitArr);

            if (intersects.length > 0) {

                let rayobj = intersects[0].object;
                let raytype = (typeof (rayobj.userData) != "undefined") ? rayobj.userData.type : "all";

                this.$body.css("cursor", "pointer");

                document.dispatchEvent(new CustomEvent("raytrace_event",
                    {
                        detail: {
                            rayobjectname: rayobj.name,
                            rayintersects: intersects,
                            interaction: "hover",
                            type: raytype
                        }
                    }));

            } else {

                this.$body.css("cursor", "auto");
                document.dispatchEvent(new CustomEvent("raytrace_event",
                    {
                        detail: {
                            interaction: "nohover",
                            type: "all"
                        }
                    }));

            }



        }

    }

}




